module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
 // Content_Related Widget
(function (fox, $){
	'use strict';
	fox.registerWidget('Content_Favorites', {

		configure: function (options) {
			this.bigThumbs = {};
			this.attachedVideos = {};

			this.registerOptions('', {
				externalLoad: true,
				autoRender: true,
				widgets: {
					dl: {
						widget: 'Datalayer',
						limit: 24,
						fields: ['contentType', 'type'],
						'metaFields.resources': {
							bigThumb: 'primary..h1360i',
							originThumb: 'sources..origin',
							info: 'width,height'
						}
					},
					fullscreenView: {
						widget: 'FullscreenView',
						template: 'sitepage_gallery_fullscreenview_cutted'
					},
					previewContent: {
						widget: 'PreviewUploadedContent',
						dialog: {
							close: fox.bind(function () {
								this.dl.load();
								$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
							}, this),
						}
					}
				},
				handleWom: {
					dlLoaded: {
						event: 'loaded',
						widget: '#dl',
						callback: 'dlLoaded'
					},
				},
				list: {
					handleDom: {
						rollOver: {
							target: '.item .imgpicker',
							event: 'mouseover',
							callback: 'handlerDom:rollOver'
						},
						titleMove: {
							target: '.title',
							event: 'mouseover',
							callback: 'handlerDom:titleMove'
						},
						titleMoveBack: {
							target: '.title',
							event: 'mouseout',
							callback: 'handlerDom:titleMoveBack'
						},
						remove: {
							target: '.remove',
							event: 'click',
							callback: 'handlerDom:remove'
						},
						error: {
							target: '.item .errorimg',
							event: 'error',
							callback: 'handlerDom:errorImg'
						},
						openFullscreen: {
							target: '.fullscreen',
							event: 'click',
							callback: '@parent:openFullscreen'
						},
						openAttachedVideo: {
							event: 'click',
							target: '.attached-video',
							callback: '@parent:openAttachedVideo'
						}
					}
				}
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return ((w / h) > .84);
			});
			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#previewContent #videoPreview', {
				'hooks.onStartRendering': function () {
					var
						parent = this.getParent(),
						id = parent.currentId;

					if (!parent.STORE.hasOwnProperty(id)) {
						this.formatGetMap(id, '@parent @parent:getMapResponse');
					} else {
						this.preparePlayerData(parent.STORE[id]);
					}

					this.setTemplateOptions({
						contentId: id,
						attachTitle: parent.currentData.attachTitle,
						targetId: parent.currentResId
					});
				}
			});

			this.registerOptions('#previewContent #videoPreview #downloadLinks', {
				'hooks.onAddedToDom': function () {
					$(this.element[0]).hide();
				},
				'hooks.onStartRendering': function () {
					return true;
				}
			});

			this.registerOptions('#previewContent .Widget #favorites', {
				'hooks.onAddedToDom': function () {
					$(this.element[0]).hide();
				}
			});
		
			this.callParent('init', arguments);
		},

		// running: function () {
		// 	this.dl.load();
		//
		// 	this.callParent('running', arguments);
		// },

		activating: function () {
			this.dl.load();
			this.callParent('activating', arguments);
		},

		getImgById: function (id, c) {
			id = parseInt(id);

			if (fox.isArray(c)) {
				return c.filter(function (value, index) {
					return Number(value.id) === Number(id);
				}).pop();
			}

			return false;
		},

		openFullscreen: function (e) {
			var 
				id = $(e).attr('id'),
				photoData = this.getImgById(id, this.bigThumbs[id]);

			if (photoData) {
				this.rwom1('#fullscreenView').setPhotoCollection(this.bigThumbs[id]).setCurrentPhoto(photoData).show();
			}
		},

		dlLoaded: function (o, dl) {
			var 
				obj,
				resId,
				fType,
				fsv = this.rwom1('#fullscreenView');

			while (obj = dl.iterateObject()) {
				fType = obj.get('favoriteType');

				resId = !fox.isEmpty(obj.get('resourceId'))
					? obj.get('resourceId')
					: obj.get('favoriteType') === 'clientUploadResource' && obj.get('type') === 2
						? obj.get('_resources.bigThumb.id')
						: false;

				if (resId) {
					if (!fox.isEmpty(obj.get('_resources.bigThumb'))) {
						if (!fox.isEmpty(obj.get('_resources.originThumb.info'))) {
							this.bigThumbs[resId] = fsv.mixBigThumb(obj.get('_resources.bigThumb'), obj.get('_resources.originThumb'));
						} else {
							this.bigThumbs[resId] = obj.get('_resources.bigThumb');
						}
					}
				}

				if (fType === 'clientUploadResource' && obj.get('type') === 1) {
					this.attachedVideos[obj.get('clienUploadId')] = {
						id: obj.get('clienUploadId'),
						type: obj.get('type'),
						attachTitle: obj.get('title'),
						posterUrl: obj.get('_resources.primary.url'),
						resId: resId
					};
				}
			}
		},

		openAttachedVideo: function (el) {
			var
				attachContentId = $(el).data('attached-content'),
				pc = this.rwom1('#previewContent');

			if (attachContentId) {
				pc.show({
					collection: [],
					data: this.attachedVideos[attachContentId]
				});
			}
		},

		getMapResponse: function (res) {
			var 
				map = this.rwom1('#previewContent').fillStore(this.rwom1('#previewContent').currentId, res.answer.response),
				p = this.rwom1('#previewContent #videoPreview');

			p.preparePlayerData(map);
		}
	}, 'Content_Browser');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/favorites.js
// module id = 446
// module chunks = 4